import { COLOR_SELECT_THEME_CONFIG_LIGHT } from "constants/colors";
import { useSelector } from "react-redux";
import Select from "react-select";
import { getLocaleString } from "utils/localization/locale";

export default function TagFilter(props) {
  const {
    tags,
    value = [],
    onChange,
    showAllOption = true,
    dataCy = "tag-filter",
    placeholder = getLocaleString("receivables.select_tags", "Select tags"),
    localizedParam = { tags: getLocaleString("common.tags", "Tags") },
  } = props;
  const reduxTags = useSelector((state) => state.tag && state.tag.allTags);
  const allTags = tags
    ? tags
    : localStorage.getItem("tag_list")
      ? JSON.parse(localStorage.getItem("tag_list"))
      : reduxTags;
  const options = allTags || [];
  let _options = [...options.map((x) => ({ value: x.id, label: x.name }))];
  _options =
    showAllOption && _options.length
      ? [
          {
            value: "all_tags",
            label: getLocaleString(
              "common.select_all_items",
              "Select All Tags",
              localizedParam
            ),
          },
          ..._options,
        ]
      : _options;
  const _value = _options.filter((x) => value.includes(x.value));

  return (
    <span className="t-14 t-black" data-cy={dataCy}>
      <Select
        placeholder={placeholder}
        isSearchable={true}
        isMulti={true}
        styles={
          typeof COLOR_SELECT_THEME_CONFIG_LIGHT !== "undefined"
            ? COLOR_SELECT_THEME_CONFIG_LIGHT
            : {}
        }
        options={_options}
        components={{
          ClearIndicator: (props) => {
            const {
              getClassNames,
              getStyles,
              innerProps: { ref, ...restInnerProps },
            } = props;
            return (
              <div
                {...restInnerProps}
                onMouseDown={(e) => {
                  e.stopPropagation();
                  restInnerProps.onMouseDown(e);
                }}
                className={getClassNames("clearIndicator", props)}
              >
                <div style={{ ...getStyles("clearIndicator", props) }}>
                  <i className="fa fa-times t-14" />
                </div>
              </div>
            );
          },
        }}
        label="Tags"
        onChange={(e) => onChange(e ? e.map((x) => x.value) : [])}
        value={_value}
      />
    </span>
  );
}
